module.exports = __webpack_public_path__ + "img/multiplier_free_10.3ab164d6.png";